let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hkNE9")).then(() => parcelRequire('kMmgw'));